const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
const CONTENT_API = API_BASE.endsWith('/tvc') ? API_BASE : `${API_BASE}/tvc`;

export const fetchContent = async (sectionKey) => {
  try {
    const res = await fetch(`${CONTENT_API}/content/${sectionKey}`);
    if (!res.ok) throw new Error('Content not found');
    const data = await res.json();
    return data.section;
  } catch (err) {
    console.warn(`[ContentService] Failed to fetch ${sectionKey}:`, err);
    return null;
  }
};
